module.exports = __webpack_public_path__ + "static/media/hairdryer.e7e790a0.png";